import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { GRAY_DARKEST } from "../../constants";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 140
  },
  select: {
    backgroundColor: GRAY_DARKEST
  }
}));

export default function BasicSelect(props) {
  const {
    handleChange,
    label = "Filters",
    showAllOption = false,
    value
  } = props;
  let { options } = props;
  const classes = useStyles();

  const onChange = change => {
    const value = change.target.value;
    handleChange(value);
  };

  // if options is an array of object, use id and name. Otherwise convert the array of strings to an array of objects where id === name

  if (options && options.length > 0) {
    if (typeof options[0] !== "object") {
      options = options.map(o => {
        return { id: o, name: o };
      });
    }
  }

  return (
    <FormControl variant="filled" className={classes.formControl}>
      <InputLabel>{value || label}</InputLabel>
      <Select
        disableUnderline
        className={classes.select}
        id={`demo-simple-select-filled-${label}`}
        value={value}
        onChange={onChange}
      >
        {showAllOption ? <MenuItem value="All">All</MenuItem> : null}

        {options.map(item => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

BasicSelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.object)
  ]),
  showAllOption: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
